import Swiper from "swiper/bundle";
import 'swiper/css';
import 'swiper/css/navigation';

export function handleTabs2() {
    const tabsPanel = document.querySelectorAll(".gallery-with-text .tabs-panel");
    const tabsAnchor = document.querySelectorAll('.gallery-with-text .tabs-list__anchor');
    if(!tabsPanel.length && !tabsAnchor.length) return;

    const hash = window.location.hash;
    const tabsInDom = []
    for (let i = 0; i < tabsPanel.length; i++){
        tabsInDom.push({
            label: tabsPanel[i].getAttribute("data-tab"),
            index: i
        })
    }
    const setInitialTabActived = (tabLabel) => {
        tabsInDom.forEach(tab => {
            if(tab.label.includes(tabLabel)){
                tabsAnchor[tab.index].parentElement.setAttribute('aria-selected', "true")
                tabsPanel[tab.index].setAttribute('aria-hidden', "false")
                tabsAnchor[tab.index].parentElement.classList.add("active");
                tabsPanel[tab.index].style.display = "flex";
            }  
        })
    }

    switch (true) {
        case hash.includes("diseño") && tabsInDom.some(tab => tab.label.includes("diseño")):
            setInitialTabActived("diseño")
        break;
        case hash.includes("performance") && tabsInDom.some(tab => tab.label.includes("performance")):
            setInitialTabActived("performance")
        break;
        case hash.includes("seguridad") && tabsInDom.some(tab => tab.label.includes("seguridad")):
            setInitialTabActived("seguridad")
        break
        default:
            // Setea los primeros valores
            tabsAnchor[0].parentElement.setAttribute('aria-selected', "true")
            tabsPanel[0].setAttribute('aria-hidden', "false")
            tabsAnchor[0].parentElement.classList.add("active");
            tabsPanel[0].style.display = "flex";
        break;
    }

    tabsAnchor.forEach((btn, index) => btn.addEventListener("click", () => itemCb(index)));

    function itemCb(index) {
        for (let i = 0; i < tabsPanel.length; i++) {
            tabsPanel[i].style.display = "none";
            tabsPanel[i].setAttribute("aria-hidden", "true");
            tabsPanel[index].style.display = "flex"
            tabsPanel[index].setAttribute("aria-hidden", "false");
        }
        for (let i = 0; i < tabsAnchor.length; i++) {
            tabsAnchor[i].parentElement.classList.remove("active");
            tabsAnchor[i].parentElement.setAttribute("aria-selected", "false");
            tabsAnchor[index].parentElement.classList.add("active");
            tabsAnchor[index].parentElement.setAttribute("aria-selected", "true");
        }
    }
}

export function handleGalleryWithTextFilter() {
    const btn = document.querySelector(".gallery-with-text-filters-mobile__button")
    const close = document.querySelector(".gallery-with-text-filters-mobile__modal_close")
    const modal = document.querySelector(".gallery-with-text-filters-mobile__modal")
    const tabsList = document.querySelector('.gallery-with-text-tabs-list_mobile');
    const selectedOption = document.querySelector('.gallery-with-text-selected-option');

    btn?.addEventListener("click", () => {
        modal.style.display = "flex";
    })

    close?.addEventListener("click", () => {
        modal.style.display = "none";
    })
    
    tabsList?.addEventListener('click', (e) => {
        e.preventDefault();
    
        const tabName = e.target.getAttribute('href').slice(1);
        const tabsPanels = document.querySelectorAll('.gallery-with-text .tabs-panel');

        modal.style.display = "none";
    
        tabsPanels?.forEach((tab) => {
            if (tab.getAttribute('data-tab') === tabName) {
                tab.style.display = 'block';
                selectedOption.innerHTML = tabName;
            } else {
                tab.style.display = 'none';
            }
        });
    });
}

export function gallerySwiper2() {
    if (document.querySelector(".gallery-swiper")) {
        const diseño = new Swiper(".gallery-swiper__sliders__slider", {
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: ".container_pag_nav1 .swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        const performance = new Swiper(".gallery-swiper-ext__sliders__slider", {
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: ".container_pag_nav2 .swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

        const seguridad = new Swiper(".gallery-swiper-int__sliders__slider", {
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: ".container_pag_nav3 .swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
}